<template>
  <div class="FamilyGmail">
    <a class="send-button" @click="showModal">Gmail対応履歴</a>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        Gmail対応履歴
      </template>

      <div slot="body" class="wrapper">
        <input type="text" v-model="search.user" @keyup="searchTable()" placeholder="送信対象者検索">
        <div class="mail-list">
          <table-c>
            <tr-c slot="tr-th" @click.native="push(list)" v-for="(list, index) in filteredUsers" :key="index.id" class="tr_hover">
              <td-c>{{list.user}} {{list.email}}</td-c>
            </tr-c>
          </table-c>
        </div>
        <input type="text" v-model="sendUser" placeholder="送信対象者">
      </div>

      <div class="footer" slot="footer">
        <btn @click.native="send">送信画面</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/users/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  pageName: 'user',
  pageNames: 'users'
}

export default {
  props: {
    family: Object
  },
  name: 'FamilyGmailSupport',
  data () {
    return {
      condition: {
        condition: false
      },

      sendUser: [],

      user: {
        email: ''
      },

      watch: {
        user: ''
      },

      search: {
        user: ''
      }
    }
  },
  computed: {
    users () {
      return this.$store.getters.users
    },

    filteredUsers () {
      let self = this
      return self.users.filter((user) => {
        if (user.id !== 0) {
          return user.hide_flag === 0
        }
      })
    }
  },
  watch: {
    'watch.user': function (now, old) {
      console.log(now)
      if (now) {
        this.user.email = now.email
      }
    }
  },
  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    },

    push (list) {
      this.sendUser.push(list.email)
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    send () {
      const f_name = this.family.f_name
      const l_name = this.family.l_name
      let supports = this.family.familysupports.map((support, i) => {
        let support_date = document.querySelectorAll('.gmail-support_date')
        let note = document.querySelectorAll('.gmail-note')
        return support_date[i].innerText.replace(/\n/g, '%0D%0A') + '%0D%0A' + note[i].innerText.replace(/\n/g, '%0D%0A')
      })

      // const Base64 = {
      //   encode (str) {
      //     return btoa(unescape(encodeURIComponent(str)))
      //   },
      //   decode (str) {
      //     return decodeURIComponent(escape(atob(str)))
      //   }
      // }
      //
      // const encode = Base64.encode(supports) // => "QmFzZTY044Ko44Oz44Kz44O844OJ"

      // const decode = Base64.decode(supports) // => "Base64デコード"
      // console.log(encode)
      // console.log(decode)

      // console.log('send')
      // console.log(supports)

      let url = 'https://mail.google.com/mail/?view=cm&to=' +
        // this.user.email +
        this.sendUser +

        '&su=' +
        '対応履歴 / ' + f_name + ' ' + l_name +

        '&body=' +
        // '&body=' +
        supports.join('%0D%0A%0D%0A')
      window.open(url, '_blank', 'width=800,height=600')
    }
  }
}
</script>

<style lang='scss' scoped>
.send-button {
  cursor: pointer;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  /* border-top: solid 1px #ccc; */
  max-height: 340px;
}
.mail-list {
  overflow: scroll;
  margin: 5px 0;
}
.table {
  margin: 0;
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.FamilyModal {
}
</style>



// WEBPACK FOOTER //
// FamilyGmailSupport.vue?5a19771c